
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!outcomes.browser";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'outcomes/browser';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"toolbar outcomes-toolbar\">\n    <button class=\"go_back ui-button ui-widget ui-state-default ui-corner-all\" style=\"display:none\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "back_2900f52a", "Back", options) : helperMissing.call(depth0, "t", "back_2900f52a", "Back", options)))
    + "\n    </button>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManageOutcomes), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <button class=\"add_outcome_link ui-button ui-widget ui-state-default ui-corner-all\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_a_new_outcome_cbdbe96c", "Add a New Outcome", options) : helperMissing.call(depth0, "t", "add_a_new_outcome_cbdbe96c", "Add a New Outcome", options)))
    + "\">\n      <i class=\"icon-plus\"></i>\n      <span class=\"ui-button-text\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "outcome_da397d20", "Outcome", options) : helperMissing.call(depth0, "t", "outcome_da397d20", "Outcome", options)))
    + "</span>\n    </button>\n    <button class=\"add_outcome_group ui-button ui-widget ui-state-default ui-corner-all\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_a_new_outcome_group_e3fab2fc", "Add a New Outcome Group", options) : helperMissing.call(depth0, "t", "add_a_new_outcome_group_e3fab2fc", "Add a New Outcome Group", options)))
    + "\">\n      <i class=\"icon-plus\"></i>\n      <span class=\"ui-button-text\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "group_a8f5ed9c", "Group", options) : helperMissing.call(depth0, "t", "group_a8f5ed9c", "Group", options)))
    + "</span>\n    </button>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canImportOutcomes), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <button class=\"find_outcome ui-button ui-widget ui-state-default ui-corner-all\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "find_an_outcome_919328e6", "Find an Outcome", options) : helperMissing.call(depth0, "t", "find_an_outcome_919328e6", "Find an Outcome", options)))
    + "\">\n      <i class=\"icon-search\"></i>\n      <span class=\"ui-button-text\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "find_8d605019", "Find", options) : helperMissing.call(depth0, "t", "find_8d605019", "Find", options)))
    + "</span>\n    </button>\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <button class=\"import_outcomes ui-button ui-widget ui-state-default ui-corner-all\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "import_a_set_of_outcomes_6b782192", "Import a set of Outcomes", options) : helperMissing.call(depth0, "t", "import_a_set_of_outcomes_6b782192", "Import a set of Outcomes", options)))
    + "\">\n        <i class=\"icon-upload\"></i>\n        <span class=\"ui-button-text\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "import_1b31507", "Import", options) : helperMissing.call(depth0, "t", "import_1b31507", "Import", options)))
    + "</span>\n      </button>\n    ";
  return buffer;
  }

  buffer += "<div class=\"outcomes-browser content-box\">\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.skipToolbar), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n\n\n  <div class=\"outcomes-main\">\n    <div class=\"outcomes-sidebar\">\n      <div class=\"wrapper\"></div>\n    </div>\n    <div class=\"outcomes-content\">\n    </div>\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  